import { render, staticRenderFns } from "./mine.vue?vue&type=template&id=28fc7f72&scoped=true&"
import script from "./mine.vue?vue&type=script&lang=js&"
export * from "./mine.vue?vue&type=script&lang=js&"
import style0 from "./mine.vue?vue&type=style&index=0&id=28fc7f72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc7f72",
  null
  
)

export default component.exports